import type { IntegrationCategory } from './integrationsInfo';

export type IntegrationCategoryFilter = IntegrationCategory | 'all';

export type CategoryTab = {
  value: IntegrationCategoryFilter;
  label: string;
};

// TODO(integrations_cleanup): these tab labels should eventually come from the backend alongside the integration catalog.
export const INTEGRATION_CATEGORY_TABS: CategoryTab[] = [
  { value: 'all', label: 'All' },
  { value: 'project_management', label: 'Project Management' },
  { value: 'communication', label: 'Communication' },
  { value: 'dev_tools', label: 'Dev Tools' },
  { value: 'ai_mcp', label: 'AI/MCP' },
  { value: 'other', label: 'Other' }
];

export const getInitialIntegrationCategory = (): IntegrationCategoryFilter => {
  const params = new URLSearchParams(window.location.search);
  const category = params.get('category') as IntegrationCategoryFilter | null;

  return category &&
    INTEGRATION_CATEGORY_TABS.some(tab => tab.value === category)
    ? category
    : 'all';
};
